"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IEventTypes = exports.SCHEDULE_STATUS = exports.CALENDAR_EVENT_TYPE = exports.SCHEDULE_TYPE = exports.CLINICIAN_ROLES = exports.GROUP_STATUS = exports.ASSET_TYPE = exports.CHAT_STATUS_FILTER = exports.SERVICE_STATUS = exports.PATIENT_STATUS = exports.ATTACHMENT_TYPE = exports.RPM_DEVICE_STATUS = exports.RPM_DEVICE_ACTION = exports.RPM_DEVICE_TYPE = exports.GROUP_TYPE = exports.CHAT_TYPE = exports.CHAT_STATUS = void 0;
var CHAT_STATUS;
(function (CHAT_STATUS) {
    CHAT_STATUS["ACTIVE"] = "ACTIVE";
    CHAT_STATUS["DELETED"] = "DELETED";
    CHAT_STATUS["HIDDEN"] = "HIDDEN";
})(CHAT_STATUS || (exports.CHAT_STATUS = CHAT_STATUS = {}));
var CHAT_TYPE;
(function (CHAT_TYPE) {
    CHAT_TYPE["GROUP"] = "GROUP";
    CHAT_TYPE["PRIVATE"] = "PRIVATE";
    CHAT_TYPE["BROADCAST"] = "BROADCAST";
    CHAT_TYPE["ALL_DIRECTORY_DATA"] = "ALL_DIRECTORY_DATA";
    CHAT_TYPE["DIRECTORY_DATA_MAP"] = "DIRECTORY_DATA_MAP";
})(CHAT_TYPE || (exports.CHAT_TYPE = CHAT_TYPE = {}));
var GROUP_TYPE;
(function (GROUP_TYPE) {
    GROUP_TYPE["PATIENT"] = "PATIENT";
    GROUP_TYPE["NON_PATIENT"] = "NON_PATIENT";
    GROUP_TYPE["PRIVATE"] = "PRIVATE";
    GROUP_TYPE["BROADCAST"] = "BROADCAST";
    GROUP_TYPE["HIDDEN"] = "HIDDEN";
})(GROUP_TYPE || (exports.GROUP_TYPE = GROUP_TYPE = {}));
var RPM_DEVICE_TYPE;
(function (RPM_DEVICE_TYPE) {
    RPM_DEVICE_TYPE["BLOOD_PRESSURE_DEVICE"] = "BLOOD_PRESSURE_DEVICE";
    RPM_DEVICE_TYPE["WEIGHING_SCALE_DEVICE"] = "WEIGHING_SCALE_DEVICE";
    RPM_DEVICE_TYPE["PULSE_OXIMETER_DEVICE"] = "PULSE_OXIMETER_DEVICE";
    RPM_DEVICE_TYPE["THERMOMETER_DEVICE"] = "THERMOMETER_DEVICE";
    RPM_DEVICE_TYPE["NO_DEVICE_FOUND"] = "NO_DEVICE_FOUND";
})(RPM_DEVICE_TYPE || (exports.RPM_DEVICE_TYPE = RPM_DEVICE_TYPE = {}));
var RPM_DEVICE_ACTION;
(function (RPM_DEVICE_ACTION) {
    RPM_DEVICE_ACTION["ASSIGNED"] = "ASSIGNED";
    RPM_DEVICE_ACTION["REMOVED"] = "REMOVED";
})(RPM_DEVICE_ACTION || (exports.RPM_DEVICE_ACTION = RPM_DEVICE_ACTION = {}));
var RPM_DEVICE_STATUS;
(function (RPM_DEVICE_STATUS) {
    RPM_DEVICE_STATUS["ACTIVE"] = "ACTIVE";
    RPM_DEVICE_STATUS["REMOVED"] = "REMOVED";
})(RPM_DEVICE_STATUS || (exports.RPM_DEVICE_STATUS = RPM_DEVICE_STATUS = {}));
var ATTACHMENT_TYPE;
(function (ATTACHMENT_TYPE) {
    ATTACHMENT_TYPE["DOC"] = "DOC";
    ATTACHMENT_TYPE["XLS"] = "XLS";
    ATTACHMENT_TYPE["PDF"] = "PDF";
    ATTACHMENT_TYPE["JPG"] = "JPG";
})(ATTACHMENT_TYPE || (exports.ATTACHMENT_TYPE = ATTACHMENT_TYPE = {}));
var PATIENT_STATUS;
(function (PATIENT_STATUS) {
    PATIENT_STATUS["NON_ADMIT"] = "1";
    PATIENT_STATUS["PENDING_SOC"] = "2";
    PATIENT_STATUS["ACTIVE"] = "3";
    PATIENT_STATUS["HOSPITALIZED"] = "4";
    PATIENT_STATUS["PENDING_ROC"] = "5";
    PATIENT_STATUS["DISCHARGED"] = "6";
})(PATIENT_STATUS || (exports.PATIENT_STATUS = PATIENT_STATUS = {}));
var SERVICE_STATUS;
(function (SERVICE_STATUS) {
    SERVICE_STATUS["PENDING"] = "1";
    SERVICE_STATUS["ACTIVE"] = "2";
    SERVICE_STATUS["DISCHARGED"] = "3";
    SERVICE_STATUS["END_OF_CARE"] = "4";
})(SERVICE_STATUS || (exports.SERVICE_STATUS = SERVICE_STATUS = {}));
var CHAT_STATUS_FILTER;
(function (CHAT_STATUS_FILTER) {
    CHAT_STATUS_FILTER["DATE"] = "DATE";
    CHAT_STATUS_FILTER["UNREAD_MESSAGES"] = "UNREAD";
    CHAT_STATUS_FILTER["PENDING_REFERRAL"] = "PENDING_REFERRAL";
})(CHAT_STATUS_FILTER || (exports.CHAT_STATUS_FILTER = CHAT_STATUS_FILTER = {}));
var ASSET_TYPE;
(function (ASSET_TYPE) {
    ASSET_TYPE["MEDIA"] = "MEDIA";
    ASSET_TYPE["DOCUMENT"] = "DOCUMENT";
    ASSET_TYPE["LINK"] = "LINK";
})(ASSET_TYPE || (exports.ASSET_TYPE = ASSET_TYPE = {}));
var GROUP_STATUS;
(function (GROUP_STATUS) {
    GROUP_STATUS["ACTIVE"] = "ACTIVE";
    GROUP_STATUS["DELETED"] = "DELETED";
    GROUP_STATUS["HIDDEN"] = "HIDDEN";
})(GROUP_STATUS || (exports.GROUP_STATUS = GROUP_STATUS = {}));
var CLINICIAN_ROLES;
(function (CLINICIAN_ROLES) {
    CLINICIAN_ROLES["SN"] = "SN";
    CLINICIAN_ROLES["MSW"] = "MSW";
    CLINICIAN_ROLES["OT"] = "OT";
    CLINICIAN_ROLES["HHA"] = "HHA";
    CLINICIAN_ROLES["RD"] = "RD";
    CLINICIAN_ROLES["SLP"] = "SLP";
    CLINICIAN_ROLES["PT"] = "PT";
    CLINICIAN_ROLES["CR"] = "CR";
})(CLINICIAN_ROLES || (exports.CLINICIAN_ROLES = CLINICIAN_ROLES = {}));
var SCHEDULE_TYPE;
(function (SCHEDULE_TYPE) {
    SCHEDULE_TYPE["REMINDER"] = "REMINDER";
    SCHEDULE_TYPE["REVISIT"] = "REVISIT";
    SCHEDULE_TYPE["DOCTOR_VISIT"] = "DOCTOR_VISIT";
    SCHEDULE_TYPE["MISSED_VISIT"] = "MISSED_VISIT";
    SCHEDULE_TYPE["ACTUAL_VISIT"] = "ACTUAL_VISIT";
})(SCHEDULE_TYPE || (exports.SCHEDULE_TYPE = SCHEDULE_TYPE = {}));
var CALENDAR_EVENT_TYPE;
(function (CALENDAR_EVENT_TYPE) {
    CALENDAR_EVENT_TYPE["COMPLETED"] = "COMPLETED";
    CALENDAR_EVENT_TYPE["PROJECTED"] = "PROJECTED";
})(CALENDAR_EVENT_TYPE || (exports.CALENDAR_EVENT_TYPE = CALENDAR_EVENT_TYPE = {}));
var SCHEDULE_STATUS;
(function (SCHEDULE_STATUS) {
    SCHEDULE_STATUS["NO_ACTION"] = "NO_ACTION";
    SCHEDULE_STATUS["EXECUTED"] = "EXECUTED";
})(SCHEDULE_STATUS || (exports.SCHEDULE_STATUS = SCHEDULE_STATUS = {}));
var IEventTypes;
(function (IEventTypes) {
    IEventTypes["FORM"] = "FORM";
    IEventTypes["USER_UPDATE"] = "USER_UPDATE";
})(IEventTypes || (exports.IEventTypes = IEventTypes = {}));
